import React from 'react';
import PropTypes from 'prop-types';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { Link } from 'react-router-dom';

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('FO_IndividualConsultationDocument_Document'),
			accessor: 'id',
			cell: (id, document) => <a target='blank' href={document.url}>{document.name || document.friendlyFilename}</a>
		},
		{
			header: t('FO_IndividualConsultationDocument_Created'),
			accessor: 'created',
			cell: created => moment(created).format('lll')
		},
		{
			header: t('FO_IndividualConsultationDocument_Consultation'),
			accessor: 'paymentId',
			cell: paymentId => <Link to={`/individual-consultation/${paymentId}`}>{paymentId}</Link>
		}
	];

	return (
		<div>
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

List.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		type: PropTypes.string,
		name: PropTypes.string,
		friendlyFilename: PropTypes.string,
		url: PropTypes.string,
		created: PropTypes.string
	}))
};

export default withTranslation()(List);